import { render, staticRenderFns } from "./yuanxiRecord.vue?vue&type=template&id=e2969846&scoped=true"
import script from "./yuanxiRecord.vue?vue&type=script&lang=js"
export * from "./yuanxiRecord.vue?vue&type=script&lang=js"
import style0 from "./yuanxiRecord.vue?vue&type=style&index=0&id=e2969846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2969846",
  null
  
)

export default component.exports